module.exports = __webpack_public_path__ + "static/media/creature-tree.0d30032d.svg";